import { render } from "./Notifications.vue?vue&type=template&id=a1b416da"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
script.render = render

export default script